import { addDays } from "date-fns";


export function ParseNombreMes(numeromes:number) {
    const meses = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"]
    return meses[numeromes -1]
}

export function ObtenerFechaFromIsoFormat(fechaOriginal: string | undefined) {
    if (!fechaOriginal) {
        return ""
    }
    var fecha_dividida: string[] = fechaOriginal.split("T")[0].split("-");
    return (fecha_dividida[2] + "/" + fecha_dividida[1] + "/" + fecha_dividida[0])
}

export function ObtenerFechaFormatoLocal(fechaOriginal: Date) {
    var algo = fechaOriginal.toLocaleString("es-EC", {
        timeZone: 'America/Bogota',
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    })
    return algo;
}

export function ObtenerFechaFormatoGeneralSeparados(fechaOriginal: Date | undefined, separador: string) {
    if (!fechaOriginal) {
        return ""
    }
    const fechaIsoFormat = new Date(fechaOriginal).toISOString();
    var fecha_dividida: string[] = fechaIsoFormat.split("T")[0].split("-");
    return (fecha_dividida[0] + separador + fecha_dividida[1] + separador + fecha_dividida[2])
}


export function GetTodayDateinIsoFormat() {
    var fechaActual = new Date();
    var string_FechaActualLocalZone = ObtenerFechaFormatoLocal(fechaActual);
    var partesFecha = string_FechaActualLocalZone.split("/");
    var fechaISO = `${partesFecha[2]}-${partesFecha[1]}-${partesFecha[0]}T00:00:00`
    return fechaISO;
}


function GetTodayDateDatePicker() {
    var fechaActual = new Date();
    var string_FechaActualLocalZone = ObtenerFechaFormatoLocal(fechaActual);
    var partesFecha = string_FechaActualLocalZone.split("/");
    return `${partesFecha[2]}/${partesFecha[1]}/${partesFecha[0]}`
}





export function GetTodayDateForDatePicker() {
    return GetTodayDateDatePicker();
}
export function GetTodayDateDifferenceForDatePicker(cantidadDiasAgregar: number) {
    var fechaActual = new Date();
    fechaActual.setDate(fechaActual.getDate() + +cantidadDiasAgregar);
    var string_FechaActualLocalZone = ObtenerFechaFormatoLocal(fechaActual);
    var partesFecha = string_FechaActualLocalZone.split("/");
    var fechanueva = `${partesFecha[2]}/${partesFecha[1]}/${partesFecha[0]}`
    return fechanueva;

}

export function SumarDiasFecha(fecha: Date | string, valor: number) {
    const parseFecha = typeof (fecha) === "string" ? new Date(fecha) : fecha;
    return addDays(parseFecha, valor)
}

export function SumarDiasLaboralesFecha(fecha: Date | string, dias: number, feriados: Date[]) {
    var parseFecha = typeof (fecha) === "string" ? new Date(fecha) : fecha;
    let diasSumados = 0;

    while (diasSumados < dias) {
        parseFecha = addDays(parseFecha, 1) // Sumar 1 día

        // Verificar si es día hábil (no fin de semana ni feriado)
        const diaSemana = parseFecha.getDay(); // 0=domingo, 6=sábado
        const esFinDeSemana = diaSemana === 0 || diaSemana === 6;

        const fechaNormalizada = new Date(parseFecha.getTime());
        fechaNormalizada.setHours(0, 0, 0, 0); // Normalizar a 00:00:00 para comparar

        const esFeriado = feriados.some(feriado =>
            feriado.getTime() === fechaNormalizada.getTime()
        );

        if (!esFinDeSemana && !esFeriado) {
            diasSumados++;
        }
    }

    return parseFecha;

}


export function DateSinDiferenciaHoraria(fechaOriginal: Date | string) {

    if (typeof (fechaOriginal) !== "string") {
        var offset = fechaOriginal.getTimezoneOffset()
        var difference = -offset * 60 * 1000;
        return new Date(fechaOriginal.getTime() + difference).toISOString();
    }
    else {
        return ""
    }

}